/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import AppStatic from "@/utils/AppStatic";
import {PiArrowBendRightDownThin, PiBarcodeThin, PiCoinsThin, PiWalletThin} from "react-icons/pi";
import Image from 'next/image';
import weddifyAmbassador from "@/assets/images/ambassador/weddify-ambassador.webp";

const AppAmbassadorPresentation = () => {
    return (
        <div className="relative text-[#EBE6DE]">
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-2 items-center">
                <div>
                    <h3 className="text-4xl font-bold md:text-6xl mb-6">{AppStatic.appAmbassadorPresentationHeading.ro.translation}</h3>
                    <p className="mb-6 text-base font-thin tracking-wider">{AppStatic.appAmbassadorPresentationWhatIsFirst.ro.translation}</p>
                    <p className="mb-6 text-base font-thin tracking-wider">{AppStatic.appAmbassadorPresentationWhatIsSecond.ro.translation}</p>
                    <p className="mb-6 text-base font-thin tracking-wider">{AppStatic.appAmbassadorPresentationWhatIsThird.ro.translation}</p>

                </div>
                <div className="relative">
                    <Image alt="Weddify by Diaphan" className="mx-auto object-cover"
                         src={weddifyAmbassador} loading="lazy"/>
                    <div className="mb-6 ml-14 mt-6 text-3xl md:text-4xl lg:text-6xl font-bold uppercase">
                        <p>{AppStatic.appAmbassadorPresentationHashtagFirst.ro.translation}</p>
                        <p>{AppStatic.appAmbassadorPresentationHashtagSecond.ro.translation}</p>
                        <p>{AppStatic.appAmbassadorPresentationHashtagThird.ro.translation}</p>
                    </div>
                </div>
            </div>
            <div className="text-[#AAAAAA] text-lg flex flex-wrap gap-1 items-center text-center justify-center mt-10 md:mt-20">
                {AppStatic.mainAmbassadorPresentationHowItWorksContinue.ro.translation}
                <PiArrowBendRightDownThin className="text-4xl"/>
            </div>
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-3 mt-10">
                <div className="bg-[#EBE6DE] p-4 rounded-3xl">
                    <div
                        className="text-2xl flex items-center justify-center gap-2 font-bold md:text-4xl mb-2 text-[#232323]">
                        {AppStatic.mainAmbassadorPresentationHowItWorksFirstHeader.ro.translation}
                        <PiBarcodeThin className="text-6xl"/>
                    </div>
                    <p className="mb-2 text-base px-4 font-thin text-[#232323]">
                        {AppStatic.mainAmbassadorPresentationHowItWorksFirstText.ro.translation}
                    </p>
                </div>
                <div className="bg-[#EBE6DE] p-4 rounded-3xl">
                    <div
                        className="text-2xl flex items-center justify-center gap-2 font-bold md:text-4xl mb-2 text-[#232323]">
                        {AppStatic.mainAmbassadorPresentationHowItWorksSecondHeader.ro.translation}
                        <PiCoinsThin className="text-6xl"/>
                    </div>
                    <p className="mb-w text-base px-4 font-thin text-[#232323]">
                        {AppStatic.mainAmbassadorPresentationHowItWorksSecondText.ro.translation}
                    </p>
                </div>
                <div className="bg-[#EBE6DE] p-4 rounded-3xl">
                    <div
                        className="text-2xl flex items-center justify-center gap-2 font-bold md:text-4xl mb-2 text-[#232323]">
                        {AppStatic.mainAmbassadorPresentationHowItWorksThirdHeader.ro.translation}
                        <PiWalletThin className="text-6xl"/>
                    </div>
                    <p className="mb-2 text-base px-4 font-thin text-[#232323]">
                        {AppStatic.mainAmbassadorPresentationHowItWorksThirdText.ro.translation}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AppAmbassadorPresentation;
